/** Display name: first + last, then accountName, then email local-part. */
export function getCustomerDisplayName(
  customer:
    | {
        firstName?: string | null;
        lastName?: string | null;
        accountName?: string | null;
        name?: string | null;
        email?: string | null;
      }
    | null
    | undefined,
): string {
  if (!customer) return "N/A";
  const fromNames =
    `${customer.firstName ?? ""} ${customer.lastName ?? ""}`.trim();
  if (fromNames) return fromNames;

  const account = customer.accountName?.trim() || customer.name?.trim();
  if (account) return account;

  const email = customer.email?.trim();
  if (email) return email.split("@")[0] || email;

  return "N/A";
}
